import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { timeStamp } from 'console';
import { NgIf } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['./date-range-picker.component.scss'],
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
        NgIf,
    ],
})
export class DateRangePickerComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder) {}

    @Input() baseForm;

    @Input() rangeData;

    @Input() product;

    availableFrom: Date;

    availableTo: Date;

    disabledDates;

    @Input()range = this.fb.group({
        start: [],
        end: [],
    });

     weekday=[];


    initDates = () => {
        this.weekday[0]="Sunday";
        this.weekday[1]="Monday";
        this.weekday[2]="Tuesday";
        this.weekday[3]="Wednesday";
        this.weekday[4]="Thursday";
        this.weekday[5]="Friday";
        this.weekday[6]="Saturday";
        this.disabledDates = [];
        try {
            if (this.product.availableFrom)
                this.availableFrom = new Date(this.product.availableFrom);

            if (this.product.availableTo)
                this.availableTo = new Date(this.product.availableTo);

            if (this.product.disabledDates instanceof Array) {
                this.product.disabledDates.forEach((element) => {
                    let date = new Date(element);
                    this.disabledDates.push(date.getTime());
                });
            }
            /* if (this.product?.availableDays instanceof Array) {
                this.product.availableDays.forEach((element) => {
                    this.disabledDates.push(new Date(element));
                });
            }*/
        } catch (error) {
            console.log(
                'Error initing Date range picker: ' + error?.toString()
            );
        }
    };

    ngOnInit(): void {
        this.initDates();
    }

    //filter out non-work days and or booked days
    rangeFilter = (date: Date) => {
        return false;
        if (this.availableFrom && this.availableTo) {
            return (
                date.getTime() >= this.availableFrom?.getTime() &&
                date.getTime() <= this.availableTo?.getTime() && !this.disabledDates.includes(date.getTime())
                && this.product?.availableDays.includes(this.weekday[date.getDay()]) );
        } else {
            return true;
        }
    };
}
